import ActivityContext, {IActivity, IAvatar, IPosition} from "../contexts/Activity.tsx";
import {IResolvedActivity} from "../contexts/Activity.tsx";
import {useDroppable, useDndMonitor, useDraggable, DragOverlay} from '@dnd-kit/core';
import React, {useContext, useEffect, useRef, useState} from "react";
import {ReactSVG} from "react-svg";

interface ISelectedActivitiesProps{
    activities : IResolvedActivity[],
    scale : number
    hideInactive ?: boolean,
    firstLevel ?: SVGPathElement | null,
    setFirstLevel ?: React.Dispatch<React.SetStateAction<SVGPathElement | null>>,
    offsetX?: number,
    offsetY?: number,
    active?: number
}

export function SelectedActivities ({activities, scale, hideInactive, firstLevel, setFirstLevel,offsetX,offsetY,active}:ISelectedActivitiesProps) {
    const  {avatar, resolveActivity, resolvedActivity,resolvedActivities}  = useContext(ActivityContext);
    const containerParent = document.querySelector('.personArea');
    return (<div className={'personArea '+avatar.color} style={{
        scale: scale,
        top : offsetY ? offsetY : 0,
        left : offsetX ? offsetX : 0,
    }}>
        {/*get the selected avatar*/}
        <span className={'personItem'}>
                    {avatar && <ReactSVG
                        src={avatar.image}
                        beforeInjection={(svg) => {
                            // @ts-ignore
                            svg.setAttribute('width', (avatar.width * 1.61) + 'px')
                            // @ts-ignore
                            svg.setAttribute('height', (avatar.height * 1.61) + 'px')

                        }}
                    />}
        </span>
        { avatar && <ReactSVG className={'halo'} key={'halo'} src={avatar.halo} afterInjection={ (svg) => {
            const line = svg.querySelector('path.inner-line') as SVGPathElement;
            // @ts-ignore
            window.svgEl = svg;
            svg.setAttribute('width', avatar.haloWidth + 'px')
            svg.setAttribute('height', avatar.haloHeight+ 'px')
            if (line && !firstLevel){
                setFirstLevel && setFirstLevel(line);
            }
        }}/>}
        {activities.map((item, index) => {
            return <button key={index} className={'btn-'+index} type={"button"} style={{
                // scale: '30%',
                position: 'absolute',
                left : (item.position.x + (containerParent? containerParent.clientWidth - item.position.parentWidth : 0)/2)+'px',
                top : item.position.y+'px',
                touchAction : 'none',
                opacity: active === undefined || active === index ? 1 : 0
            }}>
                <div style={{
                    opacity : index>4 && hideInactive ? 0 : 1
                }} ><ReactSVG className={ index>4 ? 'inactive' : ''} src={item.activity.image} /></div>

            </button>
        })}
    </div>);
}